export default __webpack_public_path__ + "static/media/ads.e73f387c.jpeg";